import { VisualizatorSettings } from "./visualizator-settings";
import { ObjectCreator } from "../../../../../web-graphics";

export class ChannelConfigurationCommonSettings extends VisualizatorSettings {
  constructor(settings) {
    super();
    this.signals = [];
    for (const key of Object.getOwnPropertyNames(settings)) {
      if (key == "name") {
        this.name = settings.name;
      } else if (key == "signals") {
        this.signals = VisualizatorSettings.copySettingsArray(settings.signals);
      } else {
        if (typeof settings[key] === "object" && settings[key].copy !== undefined) {
          this[key] = settings[key].copy();
        } else if (typeof settings[key] !== "function") {
          this[key] = ObjectCreator.deepCopy(settings[key]);
        }
      }
    }
  }

  copy() {
    return new ChannelConfigurationCommonSettings(this);
  }
}
